
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetomumbaiinternatinalairport() {



    const cardData =
    {
        keyword: 'Pune to Mumbai International Airport Cab',
        heading: 'Meghana Cab : Pune to Mumbai International Airport Cab',
        headingDescription: 'Meghana Cab offers Pune to Mumbai International Airport Cab services, ensuring a hassle-free, punctual, and comfortable airport transfer experience. Whether you are catching an early morning flight or arriving late at night, our well-maintained cabs and professional drivers ensure timely pick-up and drop-off. Choose from a range of vehicles—Sedan, SUV, Innova Crysta, or Tempo Traveller—based on your travel preferences and group size. Enjoy features like GPS-enabled tracking, 24/7 availability, luggage assistance, and transparent fares. Book your Pune to Mumbai International Airport Cab with Meghana Cab and travel with peace of mind, comfort, and reliability.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
  {
    "title": "Gateway of India",
    "description": "Built in 1924 overlooking the Arabian Sea, this iconic basalt arch marks Mumbai’s colonial legacy. A starting point for ferry rides to Elephanta Caves, it draws tourists, photographers, and street vendors alike. Its Indo-Saracenic architecture and historic significance—especially as the site of the last British troops' departure in 1948—make it a must-visit symbol of the city."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A UNESCO World Heritage Site and working railway station, CST dazzles with Victorian Gothic Revival architecture blending Indian motifs. Its stained glass, intricate carvings, and stone domes make it one of the most visually arresting railway terminals in the world, alive with Mumbai’s commuting pulse."
  },
  {
    "title": "Marine Drive & Chowpatty Beach",
    "description": "The sweeping arc of Marine Drive, nicknamed the Queen’s Necklace for its twinkling streetlights, is Mumbai’s favorite promenade. Locals gather here at sunset or walk down to Chowpatty Beach for local snacks like bhel puri and kulfi while enjoying ocean breezes and views of the city skyline."
  },
  {
    "title": "Elephanta Caves",
    "description": "Located on Elephanta Island, these 5th–8th century rock-cut caves are a UNESCO site known for their massive sculptures of Lord Shiva. The main cave's 20-foot Trimurti (three-faced Shiva) is a masterpiece of Indian sculpture. Reachable by ferry, it's a historic retreat from the city’s chaos."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Dedicated to Lord Ganesha, this 18th-century temple in Prabhadevi attracts millions of devotees, including celebrities and politicians. The temple is known for fulfilling wishes and its intricate gold-plated sanctum. Tuesdays are especially vibrant with long queues and chants."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "A stunning Indo-Islamic shrine built on an islet in the Arabian Sea, this 15th-century mausoleum of saint Haji Ali is connected by a narrow causeway. A symbol of secular Mumbai, it welcomes people from all faiths and offers mesmerizing views during high tide."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "This Indo-Saracenic style museum holds over 50,000 artifacts spanning Indian miniature paintings, ancient sculptures, textiles, weaponry, and decorative arts. The heritage building itself—with a grand dome and lush gardens—adds to the experience of Mumbai’s premier cultural institution."
  },
  {
    "title": "Colaba Causeway",
    "description": "A lively market street ideal for budget shopping, antiques, and fashion accessories, Colaba Causeway is also home to cafes like Leopold and eateries serving Iranian, Continental, and street foods. A favorite with tourists looking for souvenirs and street bargains."
  },
  {
    "title": "Juhu Beach",
    "description": "One of Mumbai’s longest and most visited beaches, Juhu offers a mix of street food, jogging tracks, and Bollywood celebrity sightings. Evening crowds gather for sunsets, local snacks, and a taste of coastal Mumbai life. It’s both a leisure hub and cultural hotspot."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "A massive green lung within Mumbai, this national park houses deer, leopards, birds, and the 2,000-year-old Kanheri Buddhist caves. Ideal for nature walks, safaris, and hikes, it offers a rare escape into wilderness just a short drive from city chaos."
  }
],

      "services": [
    {
        "name": "Pune to Mumbai International Airport Taxi",
        "description": "Book a reliable taxi from Pune to Mumbai International Airport for hassle-free airport transfers. Ideal for individuals or small groups, our service ensures on-time pickups, professional drivers, and smooth travel."
    },
    {
        "name": "Airport Drop Cab from Pune to Mumbai",
        "description": "Get prompt airport drop service from Pune to Mumbai with our dedicated cab rentals. We ensure timely departures and experienced chauffeurs to make your airport commute stress-free."
    },
    {
        "name": "AC Cab Pune to Mumbai Airport",
        "description": "Travel in comfort with our air-conditioned cab service from Pune to Mumbai Airport. Enjoy a cool, relaxing ride with clean interiors and courteous drivers."
    },
    {
        "name": "One Way Pune to Mumbai Airport Cab",
        "description": "Book a one-way cab from Pune to Mumbai Airport at affordable rates. Our one-way service offers convenience and value for airport travelers without return commitments."
    },
    {
        "name": "Pune Airport to Mumbai International Cab",
        "description": "Convenient cab service available from Pune Airport to Mumbai International Terminal. Our fleet ensures timely and smooth interstate airport transfers with ease."
    },
    {
        "name": "Online Booking Pune to Mumbai Airport Taxi",
        "description": "Easily book your Pune to Mumbai Airport taxi online with our user-friendly platform. Secure your ride in minutes with instant confirmation and no hidden charges."
    },
    {
        "name": "Chauffeur Driven Cab Pune to Mumbai International Airport",
        "description": "Experience premium service with our chauffeur-driven cabs from Pune to Mumbai International Airport. Trained drivers and luxury vehicles ensure a smooth and professional journey."
    },
    {
        "name": "Budget Taxi Pune to Mumbai Airport",
        "description": "Travel affordably with our budget taxi options from Pune to Mumbai Airport. Perfect for cost-conscious travelers who want dependable service at the best price."
    },
    {
        "name": "SUV Taxi Pune to Mumbai Airport Drop",
        "description": "Need extra space and comfort? Our SUV taxi from Pune to Mumbai Airport is perfect for families or groups with luggage, offering ample room and a smooth ride."
    },
    {
        "name": "Private Cab Pune to Mumbai International Terminal",
        "description": "Hire a private cab from Pune to Mumbai International Terminal for a personalized travel experience. Ideal for solo travelers, families, or VIP transfers seeking privacy and comfort."
    },
    {
        "name": "Corporate Airport Transfer Pune to Mumbai",
        "description": "Book corporate cabs for airport transfers from Pune to Mumbai. Our reliable and punctual service caters to business needs with professional drivers and well-maintained vehicles."
    },
    {
        "name": "Family Cab Pune to Mumbai Airport",
        "description": "Ensure your family travels comfortably with our spacious cabs from Pune to Mumbai Airport. Child-friendly and luggage-ready vehicles make your journey safe and stress-free."
    },
    {
        "name": "Airport Travel Cab Pune to Mumbai",
        "description": "Choose our airport travel cab service from Pune to Mumbai for a smooth, reliable experience. Our drivers are punctual and courteous, ensuring a pleasant trip every time."
    },
    {
        "name": "Comfortable Sedan Pune to Mumbai Airport",
        "description": "Ride in a comfortable sedan from Pune to Mumbai Airport. Our clean, air-conditioned sedans provide a refined travel option for individuals and small groups."
    },
    {
        "name": "24/7 Airport Cab Pune to Mumbai",
        "description": "Our 24/7 cab service from Pune to Mumbai Airport ensures you're never stranded. Day or night, book a taxi anytime with assured availability and prompt service."
    }
],
"tableData": [
    ["Pune to Mumbai International Airport Taxi", "Airport Drop Cab from Pune to Mumbai"],
    ["AC Cab Pune to Mumbai Airport", "One Way Pune to Mumbai Airport Cab"],
    ["Pune Airport to Mumbai International Cab", "Online Booking Pune to Mumbai Airport Taxi"],
    ["Chauffeur Driven Cab Pune to Mumbai International Airport", "Budget Taxi Pune to Mumbai Airport"],
    ["SUV Taxi Pune to Mumbai Airport Drop", "Private Cab Pune to Mumbai International Terminal"],
    ["Corporate Airport Transfer Pune to Mumbai", "Family Cab Pune to Mumbai Airport"],
    ["Airport Travel Cab Pune to Mumbai", "Comfortable Sedan Pune to Mumbai Airport"],
    ["24/7 Airport Cab Pune to Mumbai", ""]
],







  "whychoose": [
    {
        "WhyChooseheading": "Reliable Pune to Mumbai Airport Cab Services",
        "WhyChoosedescription": "Enjoy dependable and on-time cab services from Pune to Mumbai International Airport. We prioritize punctuality to ensure you reach the airport well before your flight departure."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Our cabs are clean, air-conditioned, and regularly serviced to provide a comfortable journey, even during long intercity rides between Pune and Mumbai."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained, courteous, and knowledgeable of the Pune-Mumbai route. They ensure a safe and smooth ride with minimal travel time."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "We offer competitive and transparent fares for Pune to Mumbai airport travel. No hidden charges—our pricing includes tolls, driver allowance, and taxes."
    },
    {
        "WhyChooseheading": "24/7 Availability and Easy Booking",
        "WhyChoosedescription": "Book your cab anytime, day or night. Our round-the-clock service ensures availability even during late-night or early-morning airport transfers."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off",
        "WhyChoosedescription": "We provide convenient doorstep pickup in Pune and direct drop-off at Mumbai International Airport, making your journey hassle-free and time-efficient."
    },
    {
        "WhyChooseheading": "Ideal for Solo Travelers, Families, and Business Trips",
        "WhyChoosedescription": "Whether you're traveling alone, with family, or on a business trip, our cab options range from sedans to SUVs, catering to different travel needs."
    },
    {
        "WhyChooseheading": "Safety and Customer Support Guaranteed",
        "WhyChoosedescription": "Your safety is our top priority. All cabs follow safety protocols, and our customer support is available 24/7 to assist with any queries or concerns during your trip."
    }
]






























    }

  const faqData = [
    {
        question: "How can I book a cab from Pune to Mumbai International Airport?",
        answer: "You can book a cab by calling Meghana Cab at +91 9075462128 or visiting our website for instant booking and confirmation."
    },
    {
        question: "What types of cabs are available for the Pune to Mumbai Airport route?",
        answer: "We offer a range of vehicles including sedans, SUVs, and tempo travellers depending on your group size and luggage needs."
    },
    {
        question: "Is the Pune to Mumbai cab service available 24/7?",
        answer: "Yes, our cab service operates round the clock to match your flight timings at Mumbai International Airport."
    },
    {
        question: "Are your drivers experienced for long-distance airport transfers?",
        answer: "Absolutely. Our drivers are well-trained, experienced, and familiar with the Pune to Mumbai route to ensure timely and safe travel."
    },
    {
        question: "What is included in the Pune to Mumbai cab fare?",
        answer: "Our fare includes fuel, tolls, and driver charges. Any additional waiting or parking charges at the airport may be extra."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ankit Sharma',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a cab from Pune to Mumbai airport with Meghana Cab. The driver was punctual and the ride was smooth. Highly recommend!”',
    },
    {
        name: 'Mrs. Kavita Joshi',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent airport transfer service! The cab was clean, driver courteous, and we reached the airport well on time.”',
    },
];














































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai International Airport Cab",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-mumbai-international-airport-cab.jpg",
  "description": "Book a reliable cab from Pune to Mumbai International Airport with Meghana Cabs. Enjoy safe, on-time airport transfers with AC Sedans, SUVs, and experienced chauffeurs. One-way and round-trip options available 24/7.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-mumbai-international-airport-cab"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Mumbai International Airport Cab | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a reliable cab from Pune to Mumbai International Airport with Meghana Cabs. Choose AC Sedans, SUVs, and professional drivers for a safe, on-time airport drop. Available 24/7 with online booking." 
  />
  <meta 
    name="keywords" 
    content="Pune to Mumbai International Airport Taxi, Airport Drop Cab from Pune to Mumbai, AC Cab Pune to Mumbai Airport, One Way Pune to Mumbai Airport Cab, Pune Airport to Mumbai International Cab, Online Booking Pune to Mumbai Airport Taxi, Chauffeur Driven Cab Pune to Mumbai International Airport, Budget Taxi Pune to Mumbai Airport, SUV Taxi Pune to Mumbai Airport Drop, Private Cab Pune to Mumbai International Terminal, Corporate Airport Transfer Pune to Mumbai, Family Cab Pune to Mumbai Airport, Airport Travel Cab Pune to Mumbai, Comfortable Sedan Pune to Mumbai Airport, 24/7 Airport Cab Pune to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/90.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetomumbaiinternatinalairport;